import { Periode } from './../../../../../models/periode.model';
import { Component, OnInit, Input } from '@angular/core';
import { PeriodeService } from '../../../../../services/periode.service';

@Component({
  selector: 'ngx-app-periode',
  templateUrl: './periode.component.html',
  styleUrls: ['./periode.component.scss']
})
export class PeriodeComponent implements OnInit {

  @Input() periode: Periode;
  constructor(private recetteService: PeriodeService) {
   /* this.recetteService.get_periodes().subscribe((res: Periode[]) => {
      this.periodes = res;
  });*/
  }
  
  ngOnInit() {
  }

}
